import STORAGE_KEY from "@/const/storage.js";
import { defaultProdRequestConfig, defaultRequestConfig } from "@/const/env.js";

const currentProtocol = window.location.protocol;

const defaultEnvRequestConfig =
  process.env.NODE_ENV === "test" || process.env.NODE_ENV === "development"
    ? defaultRequestConfig
    : defaultProdRequestConfig;

// 本地储存的请求环境变量
let mergeRequestConfig;
try {
  const requestConfig = JSON.parse(
    localStorage.getItem(STORAGE_KEY.requestConfig) || "{}"
  );
  mergeRequestConfig = { ...defaultEnvRequestConfig, ...requestConfig };
} catch (error) {
  console.error(
    "Failed to parse request configuration from localStorage:",
    error
  );
  mergeRequestConfig = { ...defaultEnvRequestConfig };
}
const createBaseUrl = (host, env, suffix) =>
  `${currentProtocol}//${host}${env}${suffix}`;

const osBaseUrl = createBaseUrl(
  mergeRequestConfig.osHost,
  mergeRequestConfig.osEnv,
  mergeRequestConfig.osSuffix
);
const erpBaseUrl = createBaseUrl(
  mergeRequestConfig.erpHost,
  mergeRequestConfig.erpEnv,
  mergeRequestConfig.erpSuffix
);
const gatewayBaseUrl = createBaseUrl(
  mergeRequestConfig.gatewayHost,
  mergeRequestConfig.gatewayEnv,
  mergeRequestConfig.gatewaySuffix
);
const apiBaseUrl = createBaseUrl(
  mergeRequestConfig.apiHost,
  mergeRequestConfig.apiEnv,
  mergeRequestConfig.apiSuffix
);
const oswebOrigin = createBaseUrl(
  mergeRequestConfig.oswebHost,
  mergeRequestConfig.oswebEnv,
  mergeRequestConfig.oswebSuffix
);

// 将上面的数据用console.table打印出来
console.table({
  erp请求域名: erpBaseUrl,
  os请求域名: osBaseUrl,
  gateway请求域名: gatewayBaseUrl,
  api请求域名: apiBaseUrl,
  osweb链接域名: oswebOrigin,
});

const origin = {
  development: {
    erpBaseUrl: "",
    erpExportBaseUrl: erpBaseUrl,
    osHost: oswebOrigin || "http://osweb-stable.yishou.com",
  },
  test: {
    erpBaseUrl,
    erpExportBaseUrl: erpBaseUrl,
    osHost: oswebOrigin || "http://osweb-stable.yishou.com",
  },
  staging: {
    erpBaseUrl,
    erpExportBaseUrl: erpBaseUrl,
    osHost: oswebOrigin || "https://osweb-prepublish.yishouapp.com",
  },
  production: {
    erpBaseUrl: "https://erp.yishouapp.com",
    erpExportBaseUrl: "https://erp.yishouapp.com",
    osHost: "https://osweb.yishouapp.com",
  },
};

export default {
  ...origin[process.env.NODE_ENV || "production"],
};



// WEBPACK FOOTER //
// ./src/const/config.js